import { render, staticRenderFns } from "./previewAdd.vue?vue&type=template&id=df679536&scoped=true"
import script from "./previewAdd.vue?vue&type=script&lang=js"
export * from "./previewAdd.vue?vue&type=script&lang=js"
import style0 from "./previewAdd.vue?vue&type=style&index=0&id=df679536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df679536",
  null
  
)

export default component.exports